import { Link } from 'react-router-dom';
import { IconSearch } from '../components/Icons';
import { btnPrimary, btnSoft } from '../components/ui';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-8 bg-white text-center">
      <span className="w-14 h-14 rounded-full bg-soft text-muted inline-flex items-center justify-center">
        <IconSearch size={26} />
      </span>
      <h1 className="text-xl font-black mt-2">找不到這個頁面</h1>
      <p className="text-sm text-muted leading-relaxed max-w-xs">連結可能已失效，或活動已下架。</p>
      <div className="flex flex-col gap-2 w-full max-w-xs mt-4">
        <Link to="/" className={btnPrimary}>看看開放報名的活動</Link>
        <Link to="/my-bookings" className={btnSoft}>我的報名</Link>
      </div>
    </div>
  );
}
